import { BaseApiClient } from '@/services/baseApiClient';
import type { RequestOptions } from '@/utils/request';
import { getQuery } from '@/components/filter/helpers';
import type {
  CreateLeaseUnitArgs,
  DeleteLeaseUnitArgs,
  GetLeaseUnitsArgs,
  GetLeaseUnitsLeasedStateArg,
  GetOneLeaseUnitArgs,
  UpdateLeaseUnitArgs,
} from './types/args';
import type {
  DeleteLeaseUnitResult,
  GetLeaseUnitsResult,
  GetOneLeaseUnitResult,
  UpdateLeaseUnitResult,
  CreateLeaseUnitResult,
  GetLeaseUnitsLeasedStateResult,
} from './types/results';
import type { ViewLeaseUnits } from './types/view';

export class LeaseUnitsApiClient extends BaseApiClient {
  constructor() {
    super('api/lease-units');
  }

  public create(payload: CreateLeaseUnitArgs): Promise<CreateLeaseUnitResult> {
    return this.http.post('', payload);
  }

  public delete(id: DeleteLeaseUnitArgs): Promise<DeleteLeaseUnitResult> {
    return this.http.delete(`${id}`);
  }

  public get<TView extends ViewLeaseUnits>(
    filter: GetLeaseUnitsArgs,
    view: TView,
    signal: RequestOptions['signal'],
  ): Promise<GetLeaseUnitsResult<TView>> {
    return this.http.get('', { query: getQuery({ ...filter, view }), signal });
  }

  public getLeasedState(
    filter: GetLeaseUnitsLeasedStateArg,
    signal: RequestOptions['signal'],
  ): Promise<GetLeaseUnitsLeasedStateResult> {
    return this.http.get(`leased-state`, {
      query: getQuery(filter),
      signal,
    });
  }

  public getOne(id: GetOneLeaseUnitArgs, signal: RequestOptions['signal']): Promise<GetOneLeaseUnitResult> {
    return this.http.get(`${id}`, { signal });
  }

  public update({ id, payload }: UpdateLeaseUnitArgs): Promise<UpdateLeaseUnitResult> {
    return this.http.patch(`${id}`, payload);
  }
}
